export const args = {
    value: 'test',
    label: 'test',
    placeholder: 'test',
    onClick: () => { console.log("city selection clicked"); }
};
export const argTypes = {};
